const NEW_CITATION_LIST_MODAL = 'new-citation-list-modal'

export const FREE_CTA = `${NEW_CITATION_LIST_MODAL}-try-free-button`
export const SIGN_IN = `${NEW_CITATION_LIST_MODAL}-sign-in`
export const SIGN_IN_BUTTON = `${NEW_CITATION_LIST_MODAL}-sign-in-button`
export const CONTINUE_CTA = `${NEW_CITATION_LIST_MODAL}-continue-button`
